<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M38 13V9a2 2 0 00-2-2H12a2 2 0 00-2 2v4H6a2 2 0 00-2 2v24a2 2 0 002 2h36a2 2 0 002-2V15a2 2 0 00-2-2zm-20.51 8h13L24 25.21zM41 17.79v18.42L26.76 27zM38.24 16l-.24.15V16zM35 10v8.1L32 20a1 1 0 00-1-1H17a1 1 0 00-1 1l-3-1.9V10zm-25 6.15L9.76 16H10zm-3 1.64L38.24 38H7z"/><path d="M17 15h14a1 1 0 000-2H17a1 1 0 000 2z"/></svg>